import React from 'react'
import Select from 'react-select'

import {
    i18nWrapper,
    withConnectWrapper,
} from '../../../validator'
import Configurator from '../../../configurator'
import { createUser } from '../../../components/shared/auth/create-user'
import { updateUser } from '../../../components/shared/auth/update-user'

const initUserForm = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    superAdmin: false,
}

class UserForm extends Configurator {
    state = {
        userForm: { ...initUserForm },
    }

    /**
     * On mount
     */
    componentDidMount() {
        if (this.props.updatedUser) {
            this.setState({ userForm: this.props.updatedUser })
        }
    }

    /**
     * Set user form data
     *
     * @param {string} key
     * @param {string} value
     */
    setUserFormData = (key, value) => {
        this.setState({
            userForm: {
                ...this.state.userForm,
                [key]: value,
            }
        })
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            updatedUser,
            successAction,
            t,
        } = this.props

        const {
            userForm,
            companiesToSelect,
        } = this.state

        return (
            <div className="d-flex flex-column p-3">
                <h2>{t('users.form.register')}</h2>
                <div className="form-group">
                    <label htmlFor="user-form-email">
                        {t('users.form.email')} *
                    </label>
                    <input
                        type="email"
                        className="form-control"
                        id="user-form-email"
                        placeholder={t('users.form.email')}
                        value={userForm.email || ''}
                        disabled={!!updatedUser}
                        onChange={event => this.setUserFormData('email', event.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="user-form-name">
                        {t('users.form.name')}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="user-form-surname"
                        placeholder={t('users.form.name')}
                        value={userForm.name || ''}
                        onChange={event => this.setUserFormData('name', event.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="user-form-surname">
                        {t('users.form.surname')}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="user-form-surname"
                        placeholder={t('users.form.surname')}
                        value={userForm.surname || ''}
                        onChange={event => this.setUserFormData('surname', event.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="user-form-phone">
                        {t('users.form.phone')}
                    </label>
                    <input
                        type="phone"
                        className="form-control"
                        id="user-form-phone"
                        placeholder={t('users.form.phone')}
                        value={userForm.phone || ''}
                        onChange={event => this.setUserFormData('phone', event.target.value)}
                    />
                </div>

                <div className="form-group">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="user-form-super-admin"
                            onChange={event => this.setUserFormData('superAdmin', event.target.checked)}
                            checked={userForm.superAdmin || false}
                        />
                        <label className="form-check-label" htmlFor="user-form-super-admin">
                            {t('users.form.superAdmin')}
                        </label>
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-sm-10">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => {
                                (updatedUser ? updateUser(updatedUser, userForm) : createUser(userForm))
                                    .then(() => {
                                        if (typeof successAction === 'function') {
                                            successAction()
                                        }
                                        this.setState({ userForm: { ...initUserForm } })
                                        alert(t('users.form.saveSuccess'))

                                    })
                                    .catch(error => alert(error))
                            }}
                        >
                            {t('users.form.save')}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withConnectWrapper(state => ({
    // companies: state.superAdmin.companies,
}))(i18nWrapper(UserForm))
